import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ParseService } from '../../../shared/common/parse/parse.service';
import { Router } from '@angular/router';
import { QueryInterface } from '../../../shared/common/parse/query-interface';
import { Location } from '@angular/common';
import { LazyLoadEvent } from 'primeng/primeng';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss'],
  animations: fuseAnimations
})
export class EmployeesComponent implements OnInit {

  profileValue: any;
  yearFilter: number;
  firstname: String;
  lastname: String;
  userId = this.parseService.instance.User.current().id;
  rowData = [];
  value: any;
  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  yearTimeout: any;
  cols: any[];
  roleDD = [];
  report: any;
  reportingList = [];
  reportingToDD = [];
  rollOptions: SelectItem[];
  deptDD = [];
  bloodGroup = [];
  deptOptions: SelectItem[];
  bloodGroupOptions: SelectItem[];
  locationDD = [];
  locationOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  selectRoll: string[];
  selectBloodGroup: string[];
  selectReporting: string[];
  selectLocation: string[];
  selectDepartment: string[];
  profileId = '';
  empRole = '';
  tabIndex = 0;
  selectRoll1: string[];
  selectBloodGroup1: string[];
  selectReporting1: string[];
  selectLocation1: string[];
  selectDepartment1: string[];
  selectRollLongLeave: string[];
  selectBloodGroupLongLeave: string[];
  selectReportingLongLeave: string[];
  selectLocationLongLeave: string[];
  selectDepartmentLongLeave: string[];
  customRoles = [];
  employeesList: string;
  experienceTableLocations: SelectItem[];
  experienceTableDesignations: SelectItem[];
  reportingOptions: SelectItem[];
  top10ExperienceCandidates = [];
  last10ExperienceCandidates = [];

  // Experience graph
  data = [
    { 'name': "> 95", 'value': 765 },
    { 'name': "90 - 94", 'value': 123 },
    { 'name': "< 90", 'value': 84 }
  ]
  listOfExperience = [
    { 'name': '0 - 2' },
    { 'name': '2 - 4' },
    { 'name': '4 - 6' },
    { 'name': '6 - 8' },
    { 'name': '8 - 10' },
    { 'name': '> 10' }
  ]

  colorScheme = {
    domain: [
      '#64B5F6',
      '#76D7C4',
      '#B39DDB',
      '#CE93D8',
      '#A1887F',
      '#AEB6BF'
    ]
  };
  experienceGraphData = [];
  view: any[] = [720, 520];
  ngxChartWidth = 2.5;
  // options
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';


  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showXAxisLabel = true;
  xAxisLabel = 'Experience in years';
  showYAxisLabel = true;
  yAxisLabel = 'Employees Count';

  experienceTableData = [];
  experienceTableColumns: any[];
  selectedExperience: string;
  experienceTableRecords: number;
  barGraphValues: any;

  // Primeng
  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 10,
          beginAtZero: true
        }
      }]
    }
  }
  profileResults: any;
   

  constructor(
    public dialog: MatDialog,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private _location: Location,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private hardCodedValues: HardCodedValues,
    private spinner: NgxSpinnerService,
    private getReportingToService: GetReportingToService,
  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
     

    this.cols = [
      { field: 'position', header: 'S.No' },
      { field: 'profileImageInfo', header: 'Profile' },
      { field: 'userName', header: 'Name' },
      { field: 'action', header: 'Action' },
      { field: 'designation', header: 'Designation' },
      { field: 'reportingTo', header: 'Reporting To' },
      { field: 'department', header: 'Department' },
      { field: 'location', header: 'Location' },
      { field: 'officialEmail', header: 'Email' },
      // { field: 'bloodGroup', header: 'Blood Group' }
    ];

    this.experienceTableColumns = [
      { field: 'position', header: 'S.No' },
      { field: 'profileImageInfo', header: 'Profile' },
      { field: 'userName', header: 'Name' },
      { field: 'totalExperience', header: 'Experience' },
      { field: 'designation', header: 'Designation' },
      { field: 'reportingTo', header: 'Reporting To' },
      { field: 'location', header: 'Location' },
    ];

  }

  ngOnInit() {
    // this.getBloodGroup();
    this.getLocation();
    this.getDepartment();
    this.getRollOption();
    this.getReportingTo();
    // this.getEmployees();

    let filter = JSON.parse(localStorage.getItem('employeesTable'));
    if (filter != null) {
      if (filter.filters['department'] != undefined) {
        this.selectDepartment = filter.filters['department'].value;
      }
      if (filter.filters['reportingTo'] != undefined) {
        this.selectReporting = filter.filters['reportingTo'].value;
      }
      if (filter.filters['location'] != undefined) {
        this.selectLocation = filter.filters['location'].value;
      }
      if (filter.filters['role'] != undefined) {
        this.selectRoll = filter.filters['role'].value;
      }
      if (filter.filters['personalInfo.bloodGroup'] != undefined) {
        this.selectBloodGroup = filter.filters['personalInfo.bloodGroup'].value;
      }
    }

    let filter1 = JSON.parse(localStorage.getItem('releasedTable'));
    if (filter1 != null) {
      if (filter1.filters['department'] != undefined) {
        this.selectDepartment1 = filter1.filters['department'].value;
      }
      if (filter1.filters['reportingTo'] != undefined) {
        this.selectReporting1 = filter1.filters['reportingTo'].value;
      }
      if (filter1.filters['location'] != undefined) {
        this.selectLocation1 = filter1.filters['location'].value;
      }
      if (filter1.filters['role'] != undefined) {
        this.selectRoll1 = filter1.filters['role'].value;
      }
      if (filter1.filters['personalInfo.bloodGroup'] != undefined) {
        this.selectBloodGroup1 = filter1.filters['personalInfo.bloodGroup'].value;
      }
    }

    let filter2 = JSON.parse(localStorage.getItem('longLeaveTable'));
    if (filter2 != null) {
      if (filter2.filters['department'] != undefined) {
        this.selectDepartmentLongLeave = filter2.filters['department'].value;
      }
      if (filter2.filters['reportingTo'] != undefined) {
        this.selectReportingLongLeave = filter2.filters['reportingTo'].value;
      }
      if (filter2.filters['location'] != undefined) {
        this.selectLocationLongLeave = filter2.filters['location'].value;
      }
      if (filter2.filters['role'] != undefined) {
        this.selectRollLongLeave = filter2.filters['role'].value;
      }
      if (filter2.filters['personalInfo.bloodGroup'] != undefined) {
        this.selectBloodGroupLongLeave = filter2.filters['personalInfo.bloodGroup'].value;
      }
    }

  }
  /* 
  ** ==========================================================
  **  Get Roll Details
  ** ==========================================================
  */
  getRollOption() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        result.push({ name: roleList.name, id: roleList.objectId });
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
      this.experienceTableDesignations = this.bindExperienceDropDown(this.roleDD);
    });
  }

  /*
  ** ==========================================================
  ** Getting Reporting To Details
  ** ==========================================================
  */
  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  /*
  ** ==========================================================
  ** Getting Blood Group Details
  ** ==========================================================
  */
  async getBloodGroup() {
    let bloodGroupList = []
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let results = await query.find();
    let result = results[0];
    let bloodGroup = result.get('bloodGroup')
    bloodGroup.forEach(element => {
      bloodGroupList.push(element.value)
    });
    this.bloodGroup = bloodGroupList;
    this.bloodGroupOptions = this.bindBloodGroupDD(this.bloodGroup)
  }

  /*
  ** ==========================================================
  ** Getting Department Details
  ** ==========================================================
  */
  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  /*
  ** ==========================================================
  ** Getting Office Locations
  ** ==========================================================
  */
  async getLocation() {
    await this.getReportingToService.getLocation().then(res => {
      this.locationOptions = res;
      this.experienceTableLocations = this.bindExperienceDropDown(this.locationOptions);
    });
  }

  bindDropDown(array) {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  bindExperienceDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }

  bindBloodGroupDD(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  /* 
  ** ==========================================================
  **  Get Employees Function
  ** ==========================================================
  */
  async getEmployees() {
    let condition = [];
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    await query.find().then(res => {
      let roleDetail = res[0];
      this.customRoles = roleDetail.get('customRoles');
      let employeesdata = this.customRoles[0];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });
      this.employeesList = filtered[0];
    });

    if (this.employeesList == 'All') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: this.tabIndex == 1 ? false : true },
        { condition: 'equalTo', field: 'isLongLeave', value: this.tabIndex == 2 ? true : false },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
        { condition: 'limit', value: 10 },
      ];
    }
    else if (this.employeesList == 'Assigned') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: this.tabIndex == 1 ? false : true },
        { condition: 'equalTo', field: 'isLongLeave', value: this.tabIndex == 2 ? true : false },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
        { condition: 'limit', value: 10 },
        { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
      ];
    }

    // if (this.empRole == 'Leader') {
    //   condition.push({
    //     condition: 'equalTo', field: 'profile',
    //     value: {
    //       __type: 'Pointer',
    //       className: 'Profile',
    //       objectId: this.profileId
    //     }
    //   });
    // }
    this.totalRecords = await this.getResourcesCount();
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      this.rowData = this.loadResources(results, 0);
    });
  }

  tabChange(event) {
    this.tabIndex = event.index;
    if (this.tabIndex == 3) {
      this.getExperienceChart();
    }
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */
  async onLazyLoadResources(event: LazyLoadEvent) {
    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    await query.find().then(res => {
      let roleDetail = res[0];
      this.customRoles = roleDetail.get('customRoles');
      let employeesdata = this.customRoles[0];
      var keys = Object.keys(employeesdata);
      var filtered = keys.filter(function (key) {
        if (typeof employeesdata[key] != 'string') {
          return employeesdata[key]
        }
      });
      this.employeesList = filtered[0];
    });
    this.loadEventData = event;
    let condition = [];


    if (this.employeesList == 'All') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: this.tabIndex == 1 ? false : true },
        { condition: 'equalTo', field: 'isLongLeave', value: this.tabIndex == 2 ? true : false },
        { condition: 'include', value: 'location' },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
      ];
    } else if (this.employeesList == 'Assigned') {
      condition = [
        { condition: 'equalTo', field: 'isActive', value: this.tabIndex == 1 ? false : true },
        { condition: 'equalTo', field: 'isLongLeave', value: this.tabIndex == 2 ? true : false }, { condition: 'include', value: 'location' },
        { condition: 'include', value: 'reportingTo' },
        { condition: 'include', value: 'department' },
        { condition: 'include', value: 'role' },
        { condition: 'ascending', value: 'firstName' },
        { condition: 'equalTo', field: 'reportingTo', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
      ];
    }

    if (this.tabIndex === 1) {
      condition.push({ condition: 'descending', field: 'updatedAt' })
    }
    // if (this.empRole == 'Leader') {
    //   condition.push({
    //     condition: 'equalTo', field: 'reportingTo',
    //     value: {
    //       __type: 'Pointer',
    //       className: 'Profile',
    //       objectId: this.profileId
    //     }
    //   });
    // }
    if (this.employeesList == 'All' || this.employeesList == 'Assigned') {

      const filter: any = event.filters;
      if (!filter) {
        const skip: number = event.first;

        this.totalRecords = await this.getTotalRecordsCount(condition);
        this.lazyLoadAddResources(condition, skip, event.rows);

      } else if (event.sortField) {
        const skip: number = event.first;

        let field = event.sortField;
        let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
        // tslint:disable-next-line:forin
        for (let key in filter) {
          let query = filter[key].value;
          if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;
            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
        let sortCondition = {};
        if (sortOrder == 'ascending') {
          sortCondition = { condition: sortOrder, value: field };
        } else {
          sortCondition = { condition: sortOrder, field: field };
        }
        this.totalRecords = await this.getTotalRecordsCount(condition);
        if (this.totalRecords < event.first) {
          event.first = 0;
        }
        condition.push(sortCondition);
        this.lazyLoadAddResources(condition, skip, event.rows);
      } else {
        // tslint:disable-next-line:forin
        for (let key in filter) {
          let query = filter[key].value;
          key = key == 'bloodGroup' ? 'personalInfo.bloodGroup' : key;
          if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department' || key == 'personalInfo.bloodGroup') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;

            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }

        this.totalRecords = await this.getTotalRecordsCount(condition);
        if (this.totalRecords < event.first) {
          event.first = 0;
        }
        if (this.employeesList == 'All' || this.employeesList == 'Assigned') {

          this.lazyLoadAddResources(condition, event.first, event.rows);
        }
      }
    }

  }

  lazyLoadAddResources(condition, skip, limit) {
    condition.push({ condition: 'skip', value: skip }, { condition: 'limit', value: limit });
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      this.rowData = this.loadResources(results, skip);
    });
  }

  /*
  ** ==========================================================
  ** Employees Details
  ** ==========================================================
  */
  loadResources(results, skip) {
    let i = skip;
    let result = [];
    results.forEach((element, index) => {
      i = i + 1;
      let rolePoint = element.get('role');
      let locationPoint = element.get('location');
      let reportingPoint = element.get('reportingTo');
      let officialInfo = element.get('officialInfo');
      let departmentPoint = element.get('department');
      let personalInfo = element.get('personalInfo');
      let profile = element.get('profileImageInfo');
      result.push({
        position: i,
        userName: element.get('firstName') + ' ' + element.get('lastName'),
        officialEmail: officialInfo.officialEmail,
        designation: rolePoint.get('name'),
        department: departmentPoint.get('name'),
        location: locationPoint.get('name'),
        reportingTo: reportingPoint.get('username'),
        bloodGroup: personalInfo.bloodGroup,
        profileImageInfo: profile.url,
        objectId: element.id,
        action: ''
      });
    });
    return result;
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  async getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: this.tabIndex == 1 ? false : true },
      { condition: 'equalTo', field: 'isLongLeave', value: this.tabIndex == 2 ? true : false },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 10 },
    ]);
  }

  getTotalRecordsCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', condition);
  }

  viewProfile(events) {
    this.router.navigate(['profile-view', { id: events }]);
  }

  viewTimesheet(events): void {
    this.router.navigate(['timesheet-view', { id: events }]);
  }

  viewDashboard(events): void {
    this.router.navigate(['employees-dashboard', { id: events }]);
  }

  backlocation() {
    this._location.back();
  }

  async getExperienceChart() {
    this.spinner.show();
    this.experienceGraphData = [];
    let graphData = [];
    let experienceData = [];
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.include('location');
    query.include('department');
    query.include('designation');
    query.include('reportingTo');
    query.limit(10000000);
    await query.find().then(async results => {
      this.profileResults = results;
      let twilightEmployees = JSON.parse(JSON.stringify(results));
      for (const element of twilightEmployees) {
        let experienceInYear = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.year != undefined)
          && (element.officialInfo.experience.year != '') ? element.officialInfo.experience.year : 0;
        let experienceInMonth = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.month != undefined) &&
          (element.officialInfo.experience.month != '') ? element.officialInfo.experience.month : 0;
        let totalExperience = (experienceInYear + ' Year(s)' + ' ' + experienceInMonth + ' Month(s)');
        graphData.push({
          name: element.firstName + ' ' + element.lastName,
          objectId: element.objectId,
          totalExperience: totalExperience,
          experience: Number(experienceInYear + '.' + experienceInMonth)
        });
      }
      for (const element of this.listOfExperience) {
        let resources = [];
        if (element.name == '0 - 2') {
          resources = graphData.filter(x => x.experience < 2);
        }
        if (element.name == '2 - 4') {
          resources = graphData.filter(x => x.experience >= 2 && x.experience < 4);
        }
        if (element.name == '4 - 6') {
          resources = graphData.filter(x => x.experience >= 4 && x.experience < 6);
        }
        if (element.name == '6 - 8') {
          resources = graphData.filter(x => x.experience >= 6 && x.experience < 8);
        }
        if (element.name == '8 - 10') {
          resources = graphData.filter(x => x.experience >= 8 && x.experience < 10);
        }
        if (element.name == '> 10') {
          resources = graphData.filter(x => x.experience >= 10);
        }
        experienceData.push({
          'name': element.name,
          'value': resources.length
        });

      }
      this.experienceGraphData = experienceData;
    });
    this.getEmployeesBasedOnExperience('0 - 2');
    this.spinner.hide();
  }

  dataSelect(event) {
    this.getEmployeesBasedOnExperience(event.name);
  }

  async getEmployeesBasedOnExperience(experience) {
    this.selectedExperience = experience;
    let selectedExperience = experience;
    let employeesData = [];
    this.experienceTableData = [];
    let twilightEmployees = JSON.parse(JSON.stringify(this.profileResults));
    for (const element of twilightEmployees) {
      let experienceInYear = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.year != undefined)
        && (element.officialInfo.experience.year != '') ? element.officialInfo.experience.year : 0;
      let experienceInMonth = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.month != undefined) &&
        (element.officialInfo.experience.month != '') ? element.officialInfo.experience.month : 0;
      let totalExperience = (experienceInYear + '.' + ' ' + experienceInMonth + ' Year(s)');
      employeesData.push({
        position: 0,
        objectId: element.objectId,
        userName: element.firstName + ' ' + element.lastName,
        location: element.location.name,
        designation: element.role.name,
        reportingTo: element.reportingTo.firstName + ' ' + element.reportingTo.lastName,
        profileImageInfo: element.profileImageInfo.url ? element.profileImageInfo.url : this.hardCodedValues.defaultProfileImg,
        totalExperience: totalExperience,
        experience: Number(experienceInYear + '.' + experienceInMonth)
      });
    }
    employeesData.sort(numberAs);
    let top10Data = employeesData;
    let last10Data = employeesData;
    this.getTop10EmployeesProjectDetails(top10Data.slice(0, 10), last10Data.slice(Math.max(last10Data.length - 10, 0)));

    let resources = [];
    if (selectedExperience == '0 - 2') {
      resources = employeesData.filter(x => x.experience < 2);
    }
    if (selectedExperience == '2 - 4') {
      resources = employeesData.filter(x => x.experience >= 2 && x.experience < 4);
    }
    if (selectedExperience == '4 - 6') {
      resources = employeesData.filter(x => x.experience >= 4 && x.experience < 6);
    }
    if (selectedExperience == '6 - 8') {
      resources = employeesData.filter(x => x.experience >= 6 && x.experience < 8);
    }
    if (selectedExperience == '8 - 10') {
      resources = employeesData.filter(x => x.experience >= 8 && x.experience < 10);
    }
    if (selectedExperience == '> 10') {
      resources = employeesData.filter(x => x.experience >= 10);
    }
    this.experienceTableData = resources.sort(numberAs);
    function numberAs(a, b) {
      return b.experience - a.experience;
    }
    this.experienceTableData.forEach((element, i) => {
      element.position = i + 1;
    });
    this.experienceTableRecords = resources.length;
  }

  getTop10EmployeesProjectDetails(top10Data, last10Data) {
    this.top10ExperienceCandidates = top10Data;
    this.last10ExperienceCandidates = last10Data;
  }

  onFilter(event, dt): any {
    event.filteredValue.forEach((element, index) => {
      element.position = index + 1;
    });
    this.experienceTableRecords = event.filteredValue.length; // count of displayed rows
  }

  onResize(event) {
    this.view = [event.target.innerWidth / this.ngxChartWidth, 400];
  }

}



export interface SelectItem {
  label?: string;
  value: any;
  styleClass?: string;
  icon?: string;
  title?: string;
  disabled?: boolean;
}
